/**
 * Update status text display
 */
export function updateStatus(text: string, active = false): void {
  const statusText = document.getElementById('status-text');
  if (statusText) {
    statusText.textContent = text;
    statusText.classList.toggle('active', active);
  }
}
